module.exports = __webpack_public_path__ + "media/new/star-blue-c0be60dc.svg";